// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__bJaz2","iconContainer":"SearchBar_iconContainer__jfpdF"};